import {AddBoardItemCommentProps} from 'components/comments';
import {useCreateActivityAPI} from 'hooks/activities';
import {ActivityInputRequest, ActivityType, CommentStatusMapper, CommentUserInfo} from 'models';
import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {sessionSelector} from 'store/auth/sessionSlice';

export const useAddBoardItemComment = ({selectedItem, addComment}: AddBoardItemCommentProps) => {
    const {userId, firstName, lastName, email} = useSelector(sessionSelector);
    const {createActivity, createActivityLoading, createActivityResponse} = useCreateActivityAPI();

    const addTaskComment = (comment: string) => {
        const status: CommentStatusMapper = {
            Active: true,
            Deleted: {status: false},
            Updated: [],
        };
        const newComment: ActivityInputRequest = {
            status: JSON.stringify(status),
            activityDate: new Date().toISOString(),
            activityType: ActivityType.Comment,
            data: comment,
            description: comment,
            user: JSON.stringify({userId, firstName, lastName, email} as CommentUserInfo),
            userId: userId,
        };
        createActivity({
            variables: {
                input: newComment,
                objectId: selectedItem.id,
                objectType: 'ItemData',
            },
        });
    };

    useEffect(() => {
        if (!createActivityLoading && createActivityResponse) {
            addComment(createActivityResponse);
        }
    }, [createActivityLoading, createActivityResponse]);

    return {
        addTaskComment,
    };
};
